import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperplane20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPaperplane20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.364 9.781a.25.25 0 0 1 0 .448L3.863 16.475a.25.25 0 0 1-.358-.27l1.015-5.45h5.064a.75.75 0 0 0 0-1.5H4.52l-1.015-5.45a.25.25 0 0 1 .358-.27zm.67 1.79c1.29-.645 1.29-2.487 0-3.131l-12.5-6.246C3.24 1.548 1.765 2.659 2.03 4.08l1.094 5.88a.3.3 0 0 1 0 .09L2.03 15.93c-.265 1.421 1.21 2.532 2.502 1.886z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperplane20);
